export * from './dealerpage.component';


// WEBPACK FOOTER //
// ./src/app/landingpages/prolongings/dealerpage/index.ts